import styled from 'styled-components';

export const SelectContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 27px;
    border-radius: 5px;
    padding: 5px;
    border: 1.14px solid #C4C4C4;
    box-shadow: 1.52061px 1.52061px 3.80152px 0px rgba(0, 0, 0, 0.40) inset;
    overflow: hidden;
`;

export const StyledSelect = styled.select`
    width: 68px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    background-color: transparent;
    color: #333;
    outline: none;
    border: none;
    font-size: 15px;
    font-weight: 600; 
    font-style: normal;
    text-align: start;
    line-height: 0;
    cursor: pointer;
`;

export const StyledOption = styled.option`
    color: #333;
    font-size: 15px;
    font-weight: 600; 
    font-style: normal;
    text-align: start;
    line-height: 0;
`;